<script>
	// From Lucide
	import { Minus } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Minus class={iconClass} />
